import { ComingSoon } from '@/components/shared/ComingSoon'
export function OperationsPage() { return <ComingSoon title="Operations" description="Production plans, prep checklists, staff shifts, and daily checklists." /> }
